<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="等级名称">
            <el-input v-model="queryParams.gradeName" placeholder="请输入等级名称进行查询" class="form-item-width"
              clearable></el-input>
          </el-form-item>

          <div class="btn-boxs">
            <div>
              <el-button icon="el-icon-plus" type="primary" @click="handledefectGradeAdd">新 增</el-button>
              <el-button :disabled="!multipleSelection.length" icon="el-icon-delete" type="danger"
                @click="batchDelete">批量删除</el-button>
            </div>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
              <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table :data="tableData" v-loading="tableLoading" border row-key="deptId" default-expand-all
        :tree-props="{ children: 'children' }" highlight-current-row max-height="447"
        :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize: '14px' }"
        @selection-change="handleSelectionChange">
        <!-- 多选 -->
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
          show-overflow-tooltip :width="tab.width">
          <template slot-scope="scope">
            <!-- 针对 status 列的特殊处理 -->
            <span v-if="tab.code === 'handleTime'">{{ scope.row.handleTime + '天' }}</span>
            <span v-else-if="tab.code === 'grade'">{{ gradeMaping[scope.row.grade] }}</span>
            <span v-else-if="tab.code === 'sysModule'">{{ sysModuleMaping[scope.row.sysModule] }}</span>
            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
            <el-button style="color:red" type="text" @click="deleteData(scope.row)" class="update-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination background :total="pageParams.total" :page="pageParams.pageNum" :limit="pageParams.pageSize"
          @pagination="onChangePages" />
      </div>
    </div>
    <!-- 添加 修改角色 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisble" width="30%" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="等级名称" prop="gradeName">
          <el-input maxlength="7" show-word-limit v-model="form.gradeName" autocomplete="off"
            placeholder="请输入等级名称"></el-input>
        </el-form-item>
        <el-form-item label="缺陷等级" prop="grade">
          <el-select v-model="form.grade" placeholder="请选择缺陷等级">
            <el-option label="一级" value="1"></el-option>
            <el-option label="二级" value="2"></el-option>
            <el-option label="三级" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属系统" prop="sysModule">
          <el-select v-model="form.sysModule" placeholder="请选择所属系统">
            <el-option v-for="item in modelTypeList" :key="item.dictCode" :label="item.dictLabel"
              :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :icon="dialogTitle === '新增' ? 'el-icon-plus' : 'el-icon-edit'" type="primary"
          @click="submitForm('form')">{{ dialogTitle === '新增' ? '立即添加' : '立即修改' }}</el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('form')">重 置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getDefectGradeList,defectGradeAdd,defectGradeById, updeteDefectGrade, deleteDefectGrade} from "@/api/data-service/defectGrade.js";
import { getSystemModel } from "@/api/admin-service/dictDataType.js";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableLoading: false,
      form: {
        gradeName: "", //等级名称
        handleTime: "", //
        grade: "",
        sysModule: "" //新增
      },
      rules: {
        gradeName: [
          { required: true, message: "请填写等级名称", trigger: "blur" }
        ],
        handleTime: [
          { required: true, message: "请输入处理时间", trigger: "blur" },
          { validator: this.validateHandleTime, trigger: "blur" }
        ],
        grade: [{ required: true, message: "请选择缺陷等级", trigger: "blur" }],
        sysModule: [
          { required: true, message: "请选择所属系统", trigger: "blur" }
        ]
      },
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      dialogFormVisble: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "等级名称", code: "gradeName", width: "" },
        { name: "缺陷等级", code: "grade", width: "" },
        { name: "所属系统", code: "sysModule", width: "" }
      ],
      gradeMaping: {
        1: "一级",
        2: "二级",
        3: "三级"
      },
      sysModuleMaping: {
        1: "1C",
        2: "2C",
        3: "3C",
        4: "4C",
        5: "5C",
        6: "浮冰监测",
        7: "隧道2C"
      },

      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        gradeName: "",
        grade: ""
      },
      multipleSelection: [],
      modelTypeList: []
    };
  },
  mounted() {
    this.onGetDataList();
    this.getSystemModel();
  },

  methods: {
    getSystemModel() {
      getSystemModel({ type: "sys_model_type" }).then(res => {
        this.modelTypeList = res?.data || [];
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchDelete() {
      this.$confirm(`提示，确定要删除选中的这些数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          // 使用 map() 来获取 defectGradeId 组成的数组
          const ids = (this.multipleSelection || []).map(
            item => item.defectGradeId
          );
          deleteDefectGrade({ ids }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 自定义校验函数
    validateHandleTime(rule, value, callback) {
      if (!value) {
        callback(new Error("请选择处理时间"));
      } else if (!/^[1-9][0-9]{0,2}$/.test(value)) {
        callback(new Error("处理时间必须是大于0且小于999的正整数"));
      } else if (parseInt(value) >= 999) {
        callback(new Error("处理时间不能大于等于999"));
      } else {
        callback();
      }
    },
    handleInput(value) {
      // 防止非数字输入
      if (value && isNaN(value)) {
        this.form.handleTime = value.slice(0, -1); // 删除最后一个字符
      }
    },
    addData() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const formData = { ...this.form };
          delete formData.defectGradeId; // 清除 defectGradeId
          if (this.dialogTitle === "新增") {
            defectGradeAdd(formData).then(res => {
              if (res.data) {
                this.$message.success(res.msg || "新增成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          } else {
            updeteDefectGrade({
              ...this.form,
              defectGradeId: this.updateId
            }).then(r => {
              if (r.data) {
                this.$message.success(r.msg || "修改成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm(`提示，确定要删除该条数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          deleteDefectGrade({ ids: [row.defectGradeId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.dialogTitle = "修改";
      this.dialogFormVisble = true;
      this.updateId = row.defectGradeId;
      defectGradeById({ id: row.defectGradeId }).then(res => {
        const data = res?.data;
        // 强制转换
        Object.assign(this.form, data);
        this.form.grade = String(data.grade);
        this.form.sysModule = String(data.sysModule);
      });
    },
    // 查
    onGetDataList() {
      this.tableLoading = true;
      getDefectGradeList({
        ...this.queryParams,
        ...this.pageParams
      })
        .then(res => {
          const { records, total } = res.data;
          this.tableData = records;
          this.pageParams.total = total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handledefectGradeAdd() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    handleDialogClose() {
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = 10;
      this.queryParams.gradeName = "";
      this.queryParams.grade = "";
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
